<template>
  <div>
    <div class="section section__teams" style="padding-bottom: 0;">
      <div class="section__wrapper">
        <div class="row mb-4">
          <div class="col">
            <div class="title-with-icon mb-2 mb-sm-0">
              <div class="title-with-icon__icon title-with-icon__icon_partners"></div>
              <div class="title-with-icon__title">Взаимодействие с ВУЗами и образовательными организациями</div>
            </div>
          </div>
        </div>

        <ul class="nav nav-tabs mb-5" id="myTab" role="tablist">
          <li class="nav-item" role="presentation">
            <a class="nav-link active" id="basic-tab" data-toggle="tab" href="#basic" role="tab" aria-controls="basic"
               aria-selected="true">Основные сведения</a>
          </li>
          <li class="nav-item" role="presentation">
            <a class="nav-link" id="hei-tab" data-toggle="tab" href="#hei" role="tab" aria-controls="hei"
               aria-selected="true">Для бизнеса</a>
          </li>
          <li class="nav-item" role="presentation">
            <a class="nav-link" id="stud-tab" data-toggle="tab" href="#stud" role="tab" aria-controls="stud"
               aria-selected="true">Для студентов</a>
          </li>
          <li class="nav-item" role="presentation" v-if="false">
            <a class="nav-link" id="konkurs-tab" data-toggle="tab" href="#konkurs" role="tab" aria-controls="stud" aria-selected="true">Студенческий турнир</a>
          </li>
        </ul>
        <div class="tab-content" id="myTabContent">
          <div class="tab-pane fade show active" id="basic" role="tabpanel" aria-labelledby="basic-tab">
            <div>
              <div class="row align-items-stretch">
                <div class="col section__acceleration-description mb-5">
                  <div class="section__acceleration-description-text mb-5">
                    <p>
                      Школа экспорта РЭЦ реализует совместные партнерские программы с высшими учебными заведениями и иными образовательными организациями: программы высшего образования (магистратура, бакалавриат) и дополнительного профессионального образования (повышение квалификации, профессиональная переподготовка), а также проекты с участием студентов ВУЗов (мастер-классы, практические стажировки, студенческие турниры).
                    </p>
                  </div>
                  <h2 class="mb-4">
                    Ключевые цели
                  </h2>
                  <div class="section__acceleration-description-text mb-4">
                    <ul>
                      <li>популяризация экспортной деятельности среди молодежной аудитории</li>
                      <li>развитие высшего и дополнительного профессионального образования в сфере ВЭД</li>
                      <li>подготовка квалифицированных кадров для реализации экспортного потенциала российских компании</li>
                    </ul>
                  </div>
                  <div class="section__acceleration-description-text">
                    <h2 class="mb-4">
                      Основные задачи
                    </h2>
                    <p>Основной задачей взаимодействия с ВУЗами является включение экспортной тематики в программы высшего образования и дополнительного профессионального образования, реализуемые на базе ВУЗов и бизнес-школ, либо посредством разработки и реализации совместных образовательных программ, либо путем передачи образовательного контента Школы экспорта РЭЦ академическим партнерам.</p>
                  </div>
                </div>
                <div class="col-md-4 mb-3 mb-md-0 section__acceleration-tag">
                  <div class="container-shadow p-24 fill-white">
                    <div class="section__acceleration-tag-img mb-24">
                      <img src="/pic/students.jpg" class="object-fit-cover"/>
                    </div>
                    <div class="section__acceleration-tag-title">
                      Хотите развивать вместе со Школой экспорта РЭЦ партнерские образовательные проекты?<br/> Напишите нам!
                    </div>
                    <a href="mailto:komarova@exportcenter.ru" class="link-target"><span>Написать</span></a>
                  </div>
                </div>
              </div>
              <div class="section__subsection_blue section__acceleration-premise section__acceleration-premise-2" style="margin-bottom: 6rem !important;">
                <div class="section__subsection-wrapper" style="padding-bottom: 12rem; padding-top: 0;">
                  <div class="row align-items-end">
                    <div class="col-12">
                      <h2 class="section__acceleration-premise-title mt-6">
                        Форматы взаимодействия со Школой экспорта РЭЦ
                      </h2>
                    </div>
                  </div>

                  <div class="section__acceleration-premise-grid container-grid">
                    <div class="container-grid__item">
                      <div class="container-grid__item-wrapper">
                        <svg width="72" height="72" viewBox="0 0 144 144" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M34.0312 75.9375H109.969V59.0625H118.406V50.625H109.969V32.3384L101.962 22.4204L95.3966 27.7206L101.531 35.3191V50.625H93.0938V46.4062C93.0938 39.141 89.4018 32.7223 83.7956 28.9271C86.9268 25.8618 88.875 21.5924 88.875 16.875C88.875 7.57013 81.3049 0 72 0C62.6951 0 55.125 7.57013 55.125 16.875C55.125 21.5924 57.0732 25.8618 60.2044 28.9271C54.5982 32.7223 50.9062 39.141 50.9062 46.4062V50.625H42.4688V35.3191L48.6034 27.7206L42.0382 22.4204L34.0312 32.3384V50.625H25.5938V59.0625H34.0312V75.9375ZM72 8.4375C76.6524 8.4375 80.4375 12.2226 80.4375 16.875C80.4375 21.5274 76.6524 25.3125 72 25.3125C67.3476 25.3125 63.5625 21.5274 63.5625 16.875C63.5625 12.2226 67.3476 8.4375 72 8.4375ZM59.3438 46.4062C59.3438 39.4276 65.0213 33.75 72 33.75C78.9787 33.75 84.6562 39.4276 84.6562 46.4062V50.625H59.3438V46.4062ZM42.4688 59.0625H101.531V67.5H42.4688V59.0625Z" fill="#fff"/>
                          <path d="M83.7956 113.865C86.9268 110.799 88.875 106.53 88.875 101.812C88.875 92.5076 81.3049 84.9375 72 84.9375C62.6951 84.9375 55.125 92.5076 55.125 101.812C55.125 106.53 57.0732 110.799 60.2044 113.865C54.5982 117.66 50.9062 124.078 50.9062 131.344V144H93.0938V131.344C93.0938 124.078 89.4018 117.66 83.7956 113.865ZM72 93.375C76.6524 93.375 80.4375 97.1601 80.4375 101.812C80.4375 106.465 76.6524 110.25 72 110.25C67.3476 110.25 63.5625 106.465 63.5625 101.812C63.5625 97.1601 67.3476 93.375 72 93.375ZM84.6562 135.562H59.3438V131.344C59.3438 124.365 65.0213 118.688 72 118.688C78.9787 118.688 84.6562 124.365 84.6562 131.344V135.562Z" fill="#fff"/>
                          <path d="M32.8894 113.865C36.0205 110.799 37.9688 106.53 37.9688 101.812C37.9688 92.5076 30.3986 84.9375 21.0938 84.9375C11.7889 84.9375 4.21875 92.5076 4.21875 101.812C4.21875 106.53 6.16697 110.799 9.29813 113.865C3.69197 117.66 0 124.078 0 131.344V144H42.1875V131.344C42.1875 124.078 38.4955 117.66 32.8894 113.865ZM21.0938 93.375C25.7462 93.375 29.5312 97.1601 29.5312 101.812C29.5312 106.465 25.7462 110.25 21.0938 110.25C16.4413 110.25 12.6562 106.465 12.6562 101.812C12.6562 97.1601 16.4413 93.375 21.0938 93.375ZM33.75 135.562H8.4375V131.344C8.4375 124.365 14.1151 118.688 21.0938 118.688C28.0724 118.688 33.75 124.365 33.75 131.344V135.562Z" fill="#fff"/>
                          <path d="M134.702 113.865C137.833 110.799 139.781 106.53 139.781 101.812C139.781 92.5076 132.211 84.9375 122.906 84.9375C113.601 84.9375 106.031 92.5076 106.031 101.812C106.031 106.53 107.979 110.799 111.111 113.865C105.504 117.66 101.812 124.078 101.812 131.344V144H144V131.344C144 124.078 140.308 117.66 134.702 113.865ZM122.906 93.375C127.559 93.375 131.344 97.1601 131.344 101.812C131.344 106.465 127.559 110.25 122.906 110.25C118.254 110.25 114.469 106.465 114.469 101.812C114.469 97.1601 118.254 93.375 122.906 93.375ZM135.562 135.562H110.25V131.344C110.25 124.365 115.928 118.688 122.906 118.688C129.885 118.688 135.562 124.365 135.562 131.344V135.562Z" fill="#fff"/>
                        </svg>
                        <h2>Проведение мероприятий</h2>
                        <div class="item-content">
                          Организация тематических мастер-классов, деловых игр, конкурсов и турниров по экспортной тематике для студентов разных курсов магистратуры и бакалавриата
                        </div>
                      </div>
                    </div>
                    <div class="container-grid__item">
                      <div class="container-grid__item-wrapper">
                        <svg width="72" height="72" viewBox="0 0 144 144" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M84.9412 0.940918V34.8233H42.5883V68.7056H0.235352V128H135.765C135.765 120.584 135.765 19.5807 135.765 0.940918H84.9412ZM51.0589 43.2939H84.9412V51.7644H51.0589V43.2939ZM51.0589 60.235H84.9412V68.7056H51.0589V60.235ZM84.9412 85.6468H51.0589V77.1762H84.9412V85.6468ZM84.9412 102.588H51.0589V94.1174H84.9412V102.588ZM8.70594 77.1762H42.5883V85.6468H8.70594V77.1762ZM8.70594 94.1174H42.5883V102.588H8.70594V94.1174ZM42.5883 119.529H8.70594V111.059H42.5883V119.529ZM84.9412 119.529H51.0589V111.059H84.9412V119.529ZM127.294 119.529H93.4118V111.059H127.294V119.529ZM127.294 102.588H93.4118V94.1174H127.294V102.588ZM127.294 85.6468H93.4118V77.1762H127.294V85.6468ZM127.294 68.7056H93.4118V60.235H127.294V68.7056ZM127.294 51.7644H93.4118V43.2939H127.294V51.7644ZM127.294 34.8233H93.4118V26.3527H127.294V34.8233ZM93.4118 17.8821V9.41151H127.294V17.8821H93.4118Z" fill="#fff"/>
                        </svg>
                        <h2>Интеграция образовательных блоков</h2>
                        <div class="item-content">
                          Включение отдельных дисциплин, курсов, тематических модулей Школы экспорта РЭЦ в программы дополнительного профессионального образования и высшего образования высших учебных заведений
                        </div>
                      </div>
                    </div>
                    <div class="container-grid__item">
                      <div class="container-grid__item-wrapper">
                        <svg width="72" height="72" viewBox="0 0 144 144" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M133.199 52.4503C135.114 49.5264 136.233 46.0356 136.233 42.2865C136.233 33.4949 130.1 26.1138 121.889 24.1827C123.225 21.8644 123.994 19.1796 123.994 16.3167C123.994 7.60133 116.904 0.510742 108.188 0.510742H26.6366V8.94824H33.0112C33.6307 9.56868 34.958 12.0442 34.958 16.3167C34.958 20.5895 33.6307 23.0647 33.0112 23.6852H11.9863V32.1227H19.9294C20.8451 32.5749 23.0054 36.1125 23.0054 42.2862C23.0057 48.4599 20.8451 51.9972 19.9294 52.4497H0V115.489H144V52.4503H133.199ZM99.3521 60.8878V86.3451H46.2254V60.8878H99.3521ZM99.3521 94.8853V107.051H27.1004V94.8853H99.3521ZM107.79 94.8853H116.608V107.051H107.79V94.8853ZM107.79 86.3449V60.8875H116.608V86.3449H107.79ZM125.046 60.8878H135.562V86.3451H125.046V60.8878ZM42.3523 8.94852H108.188C112.251 8.94852 115.557 12.2541 115.557 16.317C115.557 20.3799 112.251 23.6855 108.188 23.6855H42.3523C43.0234 21.5204 43.3955 19.0302 43.3955 16.317C43.3955 13.6038 43.0234 11.1133 42.3523 8.94852ZM29.7152 32.123L117.632 32.1227C123.236 32.1227 127.795 36.682 127.795 42.2862C127.795 47.8904 123.236 52.4497 117.632 52.4497H29.7152C30.8363 49.4845 31.4432 45.9531 31.4429 42.2862C31.4429 38.6196 30.836 35.0885 29.7152 32.123ZM8.4375 60.8878H37.7879V86.3451H8.4375V60.8878ZM8.4375 94.8853H18.6629V107.051H8.4375V94.8853ZM135.562 107.052H125.046V94.8856H135.562V107.052Z" fill="#fff"/>
                        </svg>
                        <h2>Разработка новых программ</h2>
                        <div class="item-content">
                          Разработка и реализация совместных образовательных программ на базе образовательных организаций
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <h2 class="mb-5">Партнеры</h2>
            <div class="accordion mb-6" id="acceleration-learn">
              <div class="accordion__item container-shadow">
                <div class="accordion__header" id="heading0">
                  <h2 class="collapsed" data-toggle="collapse" data-target="#collapse0" aria-expanded="true" aria-controls="collapse0">
                    Федеральные ВУЗы
                  </h2>
                </div>
                <div id="collapse0" class="collapse accordion__body show" aria-labelledby="heading0" data-parent="#acceleration-learn">
                  <div class="mb-4 row" style="margin-top: 50px;">
                    <div class="item col-lg-3 col-md-4 col-sm-6 col-xs-12" v-for="(partner, index) in ['РЭУ_им_Плеханова.png', 'ВАВТ.png', 'МГИМО.png', 'НИУ ВШЭ.png', 'РАНХиГС.png', 'Фин. университет при Правительстве.png']" :key="index">
                      <div class="section__coaches-item container-shadow" style="height: 220px; width: auto">
                        <div class="section__coaches-partner-carousel-img">
                          <img :src="'/pic/high-school/' + partner"/>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="accordion__item container-shadow">
                <div class="accordion__header" id="heading2">
                  <h2 class="collapsed" data-toggle="collapse" data-target="#collapse2" aria-expanded="true" aria-controls="collapse2">
                    Отраслевые ВУЗы
                  </h2>
                </div>
                <div id="collapse2" class="collapse accordion__body" aria-labelledby="heading2" data-parent="#acceleration-learn">
                  <div class="mb-4 row" style="margin-top: 50px;">
                    <div class="item col-lg-3 col-md-4 col-sm-6 col-xs-12" v-for="(partner, index) in ['МГТУ им. Н._Э._Баумана.png', 'РГАУ МСХА им. Тимирязева.png', 'Кузбассккая ГСХА.png', 'ГУАП.png']" :key="index">
                      <div class="section__coaches-item container-shadow" style="height: 220px; width: auto">
                        <div class="section__coaches-partner-carousel-img">
                          <img :src="'/pic/high-school/' + partner"/>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="accordion__item container-shadow">
                <div class="accordion__header" id="heading3">
                  <h2 class="collapsed" data-toggle="collapse" data-target="#collapse3" aria-expanded="true" aria-controls="collapse3">
                    Региональные ВУЗы
                  </h2>
                </div>
                <div id="collapse3" class="collapse accordion__body" aria-labelledby="heading3" data-parent="#acceleration-learn">
                  <div class="mb-4 row" style="margin-top: 50px;">
                    <div class="item col-lg-3 col-md-4 col-sm-6 col-xs-12" v-for="(partner, index) in ['НИУ ТГУ.png', 'Казанский федеральный университет.png', 'ДВФУ.png', 'Тульский государственный университет.png']" :key="index">
                      <div class="section__coaches-item container-shadow" style="height: 220px; width: auto">
                        <div class="section__coaches-partner-carousel-img">
                          <img :src="'/pic/high-school/' + partner"/>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="accordion__item container-shadow">
                <div class="accordion__header" id="heading4">
                  <h2 class="collapsed" data-toggle="collapse" data-target="#collapse4" aria-expanded="true" aria-controls="collapse4">
                    Бизнес-школы
                  </h2>
                </div>
                <div id="collapse4" class="collapse accordion__body" aria-labelledby="heading4" data-parent="#acceleration-learn">
                  <div class="mb-4 row" style="margin-top: 50px;">
                    <div class="item col-lg-3 col-md-4 col-sm-6 col-xs-12" v-for="(partner, index) in ['МШУ Сколково.png', 'СИНЕРГИЯ_Университет.png']" :key="index">
                      <div class="section__coaches-item container-shadow" style="height: 220px; width: auto">
                        <div class="section__coaches-partner-carousel-img">
                          <img :src="'/pic/high-school/' + partner"/>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="accordion__item container-shadow">
                <div class="accordion__header" id="heading5">
                  <h2 class="collapsed" data-toggle="collapse" data-target="#collapse5" aria-expanded="true" aria-controls="collapse5">
                    Академические партнеры в регионах (в рамках реализации Регионального экспортного стандарта 2.0.)
                  </h2>
                </div>
                <div id="collapse5" class="collapse accordion__body" aria-labelledby="heading5" data-parent="#acceleration-learn">
                  <div class="mb-4 row" style="margin-top: 50px;">
                    <div class="item col-lg-3 col-md-4 col-sm-6 col-xs-12" v-for="(partner, index) in [
                          'Амурский государтвенный университет.png', 'Кабардино-Балкарский Государственный Университет.png',
                          'Курский государственный университет.png', 'Рязанский государственный университет имени С.А. Есенина.png',
                          'Удмуртский государственный университет.jpg', 'Югорский государственный университет.png', 'Чувашский государственный университет имени И.Н. Ульянова.png'
                        ]" :key="index">
                      <div class="section__coaches-item container-shadow" style="height: 220px; width: auto">
                        <div class="section__coaches-partner-carousel-img">
                          <img :src="'/pic/high-school/' + partner"/>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="section__subsection_blue section__acceleration-resume section__acceleration-resume_2  mb-0">
              <div class="section__subsection-wrapper" style="padding-top: 6rem!important;">
                <h2 class="section__acceleration-resume-title">
                  Преимущества сотрудничества ВУЗов со Школой экспорта РЭЦ
                </h2>
                <div
                    class="section__acceleration-resume-grid container-grid container-grid_3 container-grid_pad-scroll">
                  <div class="container-grid__item">
                    <div class="fill-white p-24">
                      <svg width="72" height="72" viewBox="0 0 144 144" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M111.645 94.5467V65.2022L133.032 49.2505L66.9999 0L0.967773 49.2505L22.3549 65.2022V94.5467L66.9999 127.849L86.4475 113.342V135.562H77.9763V144H103.356V135.562H94.885V107.049L111.645 94.5467ZM103.207 90.3142L94.885 96.5222V77.7026L103.207 71.4954V90.3142ZM66.9999 10.5261L118.92 49.2505L66.9999 87.9747L15.0801 49.2505L66.9999 10.5261ZM66.9999 117.323L30.7924 90.3142V71.4952L66.9999 98.5008L86.4475 83.9956V102.816L66.9999 117.323Z" fill="#002E5E"/>
                      </svg>
                      <div class="item-content">
                        Даем практические, приземленные к бизнес-реалиям знания, в том числе по действующим мерам государственной поддержки экспорта
                      </div>
                    </div>
                  </div>
                  <div class="container-grid__item">
                    <div class="fill-white p-24">
                      <svg width="72" height="72" viewBox="0 0 144 144" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M135.562 0H8.4375V76.646H135.562V0ZM127.125 68.2085H16.875V8.4375H127.125V68.2085Z" fill="#002E5E"/>
                        <path d="M83.7956 113.865C86.9268 110.799 88.875 106.53 88.875 101.812C88.875 92.5076 81.3049 84.9375 72 84.9375C62.6951 84.9375 55.125 92.5076 55.125 101.812C55.125 106.53 57.0732 110.799 60.2044 113.865C54.5982 117.66 50.9062 124.078 50.9062 131.344V144H93.0938V131.344C93.0938 124.078 89.4018 117.66 83.7956 113.865ZM63.5625 101.812C63.5625 97.1601 67.3476 93.375 72 93.375C76.6524 93.375 80.4375 97.1601 80.4375 101.812C80.4375 106.465 76.6524 110.25 72 110.25C67.3476 110.25 63.5625 106.465 63.5625 101.812ZM84.6562 135.562H59.3438V131.344C59.3438 124.365 65.0213 118.688 72 118.688C78.9787 118.688 84.6562 124.365 84.6562 131.344V135.562Z" fill="#002E5E"/>
                        <path d="M32.8894 113.865C36.0205 110.799 37.9688 106.53 37.9688 101.812C37.9688 92.5076 30.3986 84.9375 21.0938 84.9375C11.7889 84.9375 4.21875 92.5076 4.21875 101.812C4.21875 106.53 6.16697 110.799 9.29813 113.865C3.69197 117.66 0 124.078 0 131.344V144H42.1875V131.344C42.1875 124.078 38.4955 117.66 32.8894 113.865ZM12.6562 101.812C12.6562 97.1601 16.4413 93.375 21.0938 93.375C25.7462 93.375 29.5312 97.1601 29.5312 101.812C29.5312 106.465 25.7462 110.25 21.0938 110.25C16.4413 110.25 12.6562 106.465 12.6562 101.812ZM33.75 135.562H8.4375V131.344C8.4375 124.365 14.1151 118.688 21.0938 118.688C28.0724 118.688 33.75 124.365 33.75 131.344V135.562Z" fill="#002E5E"/>
                        <path d="M134.702 113.865C137.833 110.799 139.781 106.53 139.781 101.812C139.781 92.5076 132.211 84.9375 122.906 84.9375C113.601 84.9375 106.031 92.5076 106.031 101.812C106.031 106.53 107.979 110.799 111.111 113.865C105.504 117.66 101.812 124.078 101.812 131.344V144H144V131.344C144 124.078 140.308 117.66 134.702 113.865ZM114.469 101.812C114.469 97.1601 118.254 93.375 122.906 93.375C127.559 93.375 131.344 97.1601 131.344 101.812C131.344 106.465 127.559 110.25 122.906 110.25C118.254 110.25 114.469 106.465 114.469 101.812ZM135.562 135.562H110.25V131.344C110.25 124.365 115.928 118.688 122.906 118.688C129.885 118.688 135.562 124.365 135.562 131.344V135.562Z" fill="#002E5E"/>
                        <path d="M62.8189 58.4669L75.6155 25.4321H87.1476V16.9946H69.8355L61.1215 39.4896L56.8676 32.5196H43.6216V40.9571H52.1325L62.8189 58.4669Z" fill="#002E5E"/>
                        <path d="M85.0892 34.1777L79.123 40.1436L85.2762 46.2968L79.123 52.45L85.0892 58.4161L91.2424 52.263L97.3956 58.4161L103.362 52.45L97.2086 46.2968L103.362 40.1436L97.3956 34.1777L91.2424 40.3306L85.0892 34.1777Z" fill="#002E5E"/>
                      </svg>
                      <div class="item-content">
                        Используем гибкие подходы, адаптивные под различные форматы сотрудничества, ориентированы на системную работу и долгосрочный результат
                      </div>
                    </div>
                  </div>
                  <div class="container-grid__item">
                    <div class="fill-white p-24">
                      <svg width="72" height="72" viewBox="0 0 144 144" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g clip-path="url(#clip0_2926_97246)">
                          <path d="M67.7578 16.9494C65.9309 17.2741 40.2145 13.9458 18.6054 35.5549C6.60751 47.5531 0 63.505 0 80.4724C0 115.579 28.4108 143.995 63.5229 143.995C80.4906 143.995 96.4425 137.388 108.44 125.39C129.915 103.916 126.728 78.0271 127.046 76.2375H67.7578V16.9494ZM59.2881 49.0742L11.0934 97.2689C9.55978 92.4934 8.66171 87.4364 8.49937 82.1965L59.2881 31.4081V49.0742ZM52.1043 26.6142L9.66396 69.0543C14.1555 47.8444 30.8947 31.106 52.1043 26.6142ZM14.6137 105.727L59.2881 61.0521V78.7183L21.7342 116.272C18.9753 113.056 16.5806 109.52 14.6137 105.727ZM118.415 84.7072C116.245 113.093 92.4547 135.526 63.5229 135.526C49.8658 135.526 37.3557 130.525 27.7231 122.261L65.277 84.7072H118.415Z" fill="#002E5E"/>
                          <path d="M125.38 18.6156C103.906 -2.85851 78.0172 0.328084 76.2275 0.00990425V67.7677H143.985C143.661 65.9408 146.989 40.2247 125.38 18.6156ZM84.6973 59.298V8.64084C111.685 10.7035 133.292 32.3106 135.354 59.298H84.6973Z" fill="#002E5E"/>
                        </g>
                        <defs>
                          <clipPath id="clip0_2926_97246">
                            <rect width="144" height="144" fill="white"/>
                          </clipPath>
                        </defs>
                      </svg>
                      <div class="item-content">
                        Входим в Группу РЭЦ, имеем прямой доступ к актуальной информации и экспертам, непрерывно актуализируем содержание образовательных программ
                      </div>
                    </div>
                  </div>
                  <div class="container-grid__item">
                    <div class="fill-white p-24">
                      <svg width="72" height="72" viewBox="0 0 144 144" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M144 92.8538V0H68.0597V33.75H55.1422C57.7966 30.222 59.3724 25.8387 59.3724 21.0938C59.3724 9.46266 49.9098 0 38.2787 0C26.6476 0 17.1849 9.46266 17.1849 21.0938C17.1849 25.8387 18.7608 30.222 21.4152 33.75H18.2818C8.20125 33.75 0 41.951 0 52.0312V95.6399H17.1248V144H59.4332V59.3159H68.06V92.8538H88.4528L81.8834 135.562H72.2798V144H139.78V135.562H130.176L123.6 92.8538H144ZM25.6227 21.0938C25.6227 14.1151 31.3003 8.4375 38.279 8.4375C45.2576 8.4375 50.9352 14.1151 50.9352 21.0938C50.9352 28.0724 45.2576 33.75 38.279 33.75C31.3003 33.75 25.6227 28.0724 25.6227 21.0938ZM50.9954 50.8784V135.562H42.4974V99.3043H34.0599V135.562H25.5623V59.1432H17.1248V87.2027H8.4375V52.0312C8.4375 46.6034 12.8537 42.1875 18.2818 42.1875H84.9347V50.8784H50.9954ZM76.4972 59.3159H93.3722V51.0218H110.25V42.5843H93.3722V33.75H76.4972V8.4375H135.562V84.4163H76.4972V59.3159ZM90.4199 135.562L92.7743 120.255H119.282L121.639 135.562H90.4199ZM117.983 111.817H94.0722L96.9891 92.8538H115.063L117.983 111.817Z" fill="#002E5E"/>
                      </svg>

                      <div class="item-content">
                        Наработали опыт, сформировали базу знаний, подготовили тренерский состав, которыми готовы делиться с партнерами
                      </div>
                    </div>
                  </div>
                  <div class="container-grid__item">
                    <div class="fill-white p-24">
                      <svg width="72" height="72" viewBox="0 0 144 144" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M135.529 85.4119V0.706055H8.47059V85.4119H0V104.471L19.7647 119.294H124.235L144 104.471V85.4119H135.529ZM127.059 9.17664V68.4708H110.118V26.1178H84.7059V34.5884H67.7647V43.059H50.8235V51.5296H33.8824V68.4708H16.9412V9.17664H127.059ZM50.8235 68.4708H42.3529V60.0002H50.8235V68.4708ZM59.2941 51.5296H67.7647V68.4708H59.2941V51.5296ZM76.2353 43.059H84.7059V68.4708H76.2353V43.059ZM93.1765 34.5884H101.647V68.4708H93.1765V34.5884ZM16.9412 76.9414H127.059V85.4119H84.7059V93.8825H59.2941V85.4119H16.9412V76.9414ZM135.529 100.235L121.412 110.824H22.5882L8.47059 100.235V93.8825H50.8235V102.353H93.1765V93.8825H135.529V100.235Z" fill="#002E5E"/>
                      </svg>
                      <div class="item-content">Предоставляем возможности для повышения квалификации преподавателей высших учебных заведений-партнеров
                      </div>
                    </div>
                  </div>
                  <div class="container-grid__item">
                    <div class="fill-white p-24">
                      <svg width="72" height="72" viewBox="0 0 144 144" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M144 72C144 66.0398 139.874 61.0281 134.329 59.6632C129.4 34.4914 109.551 14.6106 84.3417 9.67172C83.7964 7.43887 82.6512 5.38984 80.9833 3.72254C78.5831 1.32198 75.3928 0 72 0C66.0401 0 61.0278 4.12574 59.6634 9.67059C34.4911 14.6002 14.6104 34.4488 9.67172 59.6584C7.43887 60.2036 5.38984 61.3491 3.72254 63.0164C1.32198 65.4169 0 68.6073 0 72C0 77.9602 4.12574 82.9722 9.67059 84.3368C14.6008 109.512 34.4527 129.392 59.6634 134.329C61.0278 139.874 66.0401 144 72 144C77.9599 144 82.9722 139.874 84.3366 134.329C109.513 129.399 129.392 109.547 134.329 84.3368C139.874 82.9722 144 77.9602 144 72ZM135.529 72C135.529 74.3356 133.63 76.2353 131.294 76.2353H105.882C105.712 76.2353 105.544 76.2246 105.383 76.2037L105.348 76.1992C103.37 75.9561 101.848 74.3543 101.665 72.3961C101.653 72.2657 101.647 72.1336 101.647 72C101.647 70.8697 102.088 69.8067 102.888 69.0059C103.553 68.3413 104.425 67.9138 105.346 67.8008L105.383 67.7961C105.544 67.7752 105.712 67.7644 105.882 67.7644H131.294C133.63 67.7647 135.529 69.6647 135.529 72ZM83.003 99.5393C82.4499 98.5796 81.7734 97.6885 80.9836 96.8987C78.5831 94.4985 75.3928 93.1765 72 93.1765C67.3395 93.1765 63.2036 95.712 60.9936 99.5379C53.4494 96.5311 47.4692 90.5503 44.4618 83.0061C48.2877 80.7964 50.8235 76.6605 50.8235 72C50.8235 67.3395 48.2877 63.2036 44.4621 60.9939C47.4692 53.4497 53.4497 47.4692 60.9939 44.4621C63.2036 48.288 67.3395 50.8235 72 50.8235C76.6605 50.8235 80.7964 48.288 83.0061 44.4621C90.5514 47.4695 96.5325 53.4514 99.5393 60.997C98.5793 61.5501 97.6885 62.2266 96.8987 63.0164C94.4985 65.4169 93.1765 68.6073 93.1765 72C93.1765 76.6605 95.712 80.7964 99.5379 83.0061C96.5305 90.5514 90.5486 96.5328 83.003 99.5393ZM8.47059 72C8.47059 70.8697 8.91134 69.8067 9.71181 69.0059C10.5123 68.2057 11.5756 67.7647 12.7059 67.7647H38.1176C38.2879 67.7647 38.4559 67.7754 38.6166 67.7963L38.6516 67.8008C40.63 68.044 42.1522 69.6457 42.3346 71.6041C42.347 71.7346 42.3529 71.8667 42.3529 72C42.3529 72.1336 42.3467 72.2657 42.3346 72.3961C42.1522 74.354 40.63 75.9558 38.6516 76.1992L38.6166 76.2037C38.4559 76.2246 38.2879 76.2353 38.1176 76.2353H12.7059C10.3703 76.2353 8.47059 74.3356 8.47059 72ZM125.583 59.2941H107.944C104.114 48.4314 95.5686 39.8866 84.7059 36.0568V18.4168C104.843 23.1911 120.809 39.157 125.583 59.2941ZM72 8.47059C73.1303 8.47059 74.1936 8.91162 74.9938 9.71181C75.7943 10.5123 76.2353 11.5756 76.2353 12.7059V38.1176C76.2353 38.2882 76.2246 38.4559 76.2037 38.6166L76.1992 38.6516C75.9561 40.63 74.3543 42.1519 72.3961 42.3349C72.2654 42.347 72.1336 42.3529 72 42.3529C71.8664 42.3529 71.7346 42.347 71.6039 42.3349C69.6457 42.1522 68.0442 40.63 67.8008 38.6516L67.7963 38.6166C67.7754 38.4559 67.7647 38.2882 67.7647 38.1176V12.7059C67.7647 10.3705 69.6644 8.47059 72 8.47059ZM59.2941 18.4168V36.057C48.4314 39.8866 39.8866 48.4317 36.0565 59.2944H18.4168C23.1911 39.157 39.157 23.1911 59.2941 18.4168ZM18.4168 84.7059H36.0565C39.8863 95.5686 48.4314 104.113 59.2941 107.943V125.584C39.157 120.809 23.1911 104.843 18.4168 84.7059ZM72 135.529C69.6644 135.529 67.7647 133.63 67.7647 131.294V105.882C67.7647 105.712 67.7754 105.544 67.7963 105.383L67.8008 105.348C68.044 103.37 69.6457 101.848 71.6039 101.665C71.7346 101.653 71.8664 101.647 72 101.647C73.1303 101.647 74.1936 102.088 74.9938 102.889C75.6584 103.553 76.0859 104.426 76.1989 105.346L76.2037 105.384C76.2246 105.544 76.2353 105.712 76.2353 105.883V131.294C76.2353 133.63 74.3353 135.529 72 135.529ZM84.7059 125.584V107.943C95.5686 104.114 104.113 95.5686 107.944 84.7059H125.584C120.809 104.843 104.843 120.809 84.7059 125.584Z" fill="#002E5E"/>
                      </svg>
                      <div class="item-content">Обеспечиваем методологическую поддержку на всех этапах взаимодействия
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div style="margin: 12rem;" class="section__acceleration-content">
              <h2 class="mb-5">
                Основные вехи развития сотрудничества
              </h2>
              <div class="section__acceleration-content-steps">
                <div class="section__acceleration-content-step">
                  <div class="section__acceleration-content-step-wrapper">
                    <h2>2016</h2>
                    <div class="sub-title">Первое соглашение о сотрудничестве с вузом: РЭУ им. Г.В. Плеханова</div>
                    <div class="item-content">
                    </div>
                    <div class="item-content">
                    </div>
                  </div>
                </div>
                <div class="section__acceleration-content-step">
                  <div class="section__acceleration-content-step-wrapper">
                    <h2>2016-2017</h2>
                    <div class="sub-title">Серия мастер-классов Школы экспорта в ВУЗах (РАНХиГС, МГИМО, ВШЭ, МГТУ им. Баумана), заключение соглашений о сотрудничестве</div>
                    <div class="item-content">
                    </div>
                    <div class="item-content">
                    </div>
                  </div>
                </div>
                <div class="section__acceleration-content-step">
                  <div class="section__acceleration-content-step-wrapper">
                    <h2>2017-2018</h2>
                    <div class="sub-title">
                      Разработка, утверждение совместной программы проф. переподготовки с РЭУ им. Г.В. Плеханова, запуск первого потока обучения
                    </div>
                    <div class="item-content">
                    </div>
                    <div class="item-content">
                    </div>
                  </div>
                </div>
                <div class="section__acceleration-content-step">
                  <div class="section__acceleration-content-step-wrapper">
                    <h2>2018</h2>
                    <div class="sub-title">
                      Соглашение о сотрудничестве с первым региональным вузом: НИУ ТГУ
                    </div>
                    <div class="item-content">
                    </div>
                    <div class="item-content">
                    </div>
                  </div>
                </div>
                <div class="section__acceleration-content-step">
                  <div class="section__acceleration-content-step-wrapper">
                    <h2>2018-2019</h2>
                    <div class="sub-title">
                      Организовано повышение квалификации более 1,5 тыс. госслужащих по экспортной тематике (в партнерстве с РАНХиГС и университетом Синергия)
                    </div>
                    <div class="item-content">
                    </div>
                    <div class="item-content">
                    </div>
                  </div>
                </div>
                <div class="section__acceleration-content-step">
                  <div class="section__acceleration-content-step-wrapper">
                    <h2>2020</h2>
                    <div class="sub-title">
                      Запуск совместной магистерской программы по финансовым инструментам поддержки экспорта совместно с ВАВТ Минэкономразвития России
                    </div>
                  </div>
                </div>
                <div class="section__acceleration-content-step">
                  <div class="section__acceleration-content-step-wrapper">
                    <h2>2020-2021</h2>
                    <div class="sub-title">
                      Новые вузы-партнеры: РГАУ-МСХА им. Тимирязева, Финансовый университет, а также в регионах: Кузбасская ГСХА, ГУАП, Тульский государственный университет
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="tab-pane fade" id="hei" role="tabpanel" aria-labelledby="hei-tab">
            <reu/>
          </div>
          <div class="tab-pane fade" id="stud" role="tabpanel" aria-labelledby="stud-tab">
            <stud/>
          </div>
          <div v-if="false" class="tab-pane fade" id="konkurs" role="tabpanel" aria-labelledby="stud-tab">
            <concurs/>
          </div>
        </div>
      </div>
    </div>
    <page-footer/>
  </div>
</template>

<script>
import PageFooter from "../components/PageFooter";
import ApiService from "../../services/api.service";
import Reu from "../components/Reu";
import {TokenService} from "../../services/token.service";
import Stud from "../components/Stud";
import Concurs from "../components/Concurs";

export default {
  name: "HighSchool",
  components: {Concurs, Stud, Reu, PageFooter},
  data() {
    return {
      economic: [
        {
          src: '/pic/high-school/logo-hs-plehanova.png',
          alt: 'РЭУ им.Плеханова'
        },
        {
          src: '/pic/high-school/logo-hs-vavt.png',
          alt: 'ВАВТ'
        },
        {
          src: '/pic/high-school/logo-hs-mgimo.png',
          alt: 'МГИМО'
        },
        {
          src: '/pic/high-school/logo-hs-ehs.png',
          alt: 'НИУ ВШЭ'
        },
        {
          src: '/pic/high-school/logo-hs-ranhigs.png',
          alt: 'РАНХиГС'
        },
        {
          src: '/pic/high-school/logo-hs-finuniversity.png',
          alt: 'Фин. университет при Правительстве'
        },
      ],
      industry: [
        {
          src: '/pic/high-school/logo-hs-baumana.png',
          alt: 'МГТУ им. Н.Э.Баумана'
        },
        {
          src: '/pic/high-school/logo-hs-temirazeva.png',
          alt: 'РГАУ МСХА им. Тимирязева'
        },
        {
          src: '/pic/high-school/logo-hs-temirazeva.png',
          alt: 'Кузбасская ГСХА'
        },
        {
          src: '/pic/high-school/logo-hs-temirazeva.png',
          alt: 'ГУАП'
        }
      ],
      regions: [
        {
          src: '/pic/high-school/logo-hs-tsu.png',
          alt: 'НИУ ТГУ'
        },
        {
          src: '/pic/high-school/logo-hs-kfu.png',
          alt: 'Казанский-федеральный-университет'
        },
        {
          src: '/pic/high-school/logo-hs-dvfu.png',
          alt: 'ДВФУ'
        },
        {
          src: '/pic/high-school/logo-hs-tsu.png',
          alt: 'Тульский государственный университет'
        },
      ],
      schools: [
        {
          src: '/pic/high-school/logo-hs-syergy.png',
          alt: 'МШУ СКОЛКОВО'
        },
        {
          src: '/pic/high-school/logo-hs-syergy.png',
          alt: 'СИНЕРГИЯ Университет'
        }
      ],
      academs: [
        {
          src: '/pic/high-school/logo-hs-tsu.png',
          alt: 'Алтайский государственный университет'
        },
        {
          src: '/pic/high-school/logo-hs-tsu.png',
          alt: 'Амурский государственный университет'
        },
        {
          src: '/pic/high-school/logo-hs-tsu.png',
          alt: 'Кабардино-Балкарский государственный университет имени Х.М. Бербекова (КБГУ)'
        },
        {
          src: '/pic/high-school/logo-hs-tsu.png',
          alt: 'Костромской государственный университет'
        },
        {
          src: '/pic/high-school/logo-hs-tsu.png',
          alt: 'Курский государственный университет'
        },
        {
          src: '/pic/high-school/logo-hs-tsu.png',
          alt: 'Рязанский государственный университет имени С.А. Есенина'
        },
        {
          src: '/pic/high-school/logo-hs-tsu.png',
          alt: 'Удмуртский государственный университет'
        },
        {
          src: '/pic/high-school/logo-hs-tsu.png',
          alt: 'Югорский государственный университет'
        },
        {
          src: '/pic/high-school/logo-hs-tsu.png',
          alt: 'Чувашский государственный университет имени И.Н. Ульянова'
        }
      ],
      partners: [
        {
          src: '/pic/high-school/logo-hs-tsu.png',
          alt: 'Томский государственный университет'
        }
      ],
      sendForm: {}
    }
  },
  mounted() {
    this.$parent.init()
  },
  methods: {
    checkAuth() {
      if(!TokenService.getUser()) {
        window.location.href = '/sign-in'
      }
    },
    sendMail() {
      ApiService.post('region-mails', {
        sendFrom: "shepekina@exportcenter.ru,tandreeva@exportcenter.ru",
        fullName: this.sendForm.fio,
        email: this.sendForm.email,
        phone: this.sendForm.phone,
        comment: this.sendForm.text
      }).then(() => {
        this.sendForm = {}
      })
    }
  }
}
</script>

<style scoped>
.section__coaches-carousel:before, .section__coaches-partner-carousel:before {
  background: none;
}
.accordion__item {
  overflow: hidden;
}
.section__coaches-partner-carousel-img img {
  max-height: 100%;
}
</style>